<div class="zed-digital-container mat-typography">

	<div class="show-column">
		<mat-form-field style="width: 100%" [hintLabel]="selectedProgram.name && selectedProgram.name + ' (' + selectedProgram.slug + ') ' + selectedProgram.start + ' (' + selectedProgram.day + ')'">
			<mat-label>Show</mat-label>
			<mat-select [formControl]="programSelector">
				<mat-option [value]="program" *ngFor="let program of allPrograms">{{program.name}}</mat-option>
			</mat-select>
		</mat-form-field>


		<div *ngIf="selectedProgram.day && programFolder.folder" style="flex: 1; overflow: scroll;">
      <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Temporary
          </mat-panel-title>
        </mat-expansion-panel-header>
   			<app-fela-browser
    				[fileCallback]="openFile"
    				[options]="{ zedDigital: false, temporary: true, drag: true }"
    				[folder]="programFolder.folder"
    				(out)="updateFolder($event)"
    				[program]="selectedProgram"
    				[refresh]="test"
    				[playlistDate]="bruceFile">
   			</app-fela-browser>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Program Stings & Ids
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-fela-browser
      				[fileCallback]="openFile"
      				[options]="{ zedDigital: false, temporary: false, drag: true }"
      				[folder]="idsFolder"
      				(out)="updateFolder($event)"
      				[program]="selectedProgram"
      				[refresh]="test"
      				[playlistDate]="bruceFile">
     			</app-fela-browser>
      </mat-expansion-panel>
		</div>

		<div style="padding: 16px 0" *ngIf="foldermessage">
			{{foldermessage}}
		</div>

		<div *ngFor="let file of files; let i = index">
			<div style="display: flex" >
				<div style="flex: 1">
					<h4 class="name">
						{{ file?.name }}
					</h4>
				</div>
				<div class="size">
					{{ file?.size | bytes }}
				</div>
			</div>
			<mat-progress-bar mode="determinate" [value]="file?.progress"></mat-progress-bar>
		</div>

		<div *ngIf="selectedProgram.day && programFolder.folder" class="media-drop" [accept]="'audio/*,.zip'" appFileDnd (fileDropped)="onMediaDropped($event)">
			<input type="file" #mediaDropRef [accept]="'audio/*,.zip'" id="mediaDropRef" multiple (change)="mediaBrowseHandler($event.target)" />
			<label for="mediaDropRef">Drop tracks here</label>
		</div>
	</div>

	<div style="flex: 1; display: flex;">
		<div style="flex: 1; display: flex;" *ngIf="tracks">
			<app-m3u-playlist style="flex: 1; display: flex; position: relative; overflow: hidden; " [options]="{ share: 'temporary' }" [tracks]="tracks"></app-m3u-playlist>
		</div>
	</div>

</div>
